import { render, staticRenderFns } from "./Top4.vue?vue&type=template&id=4a256499&scoped=true&"
import script from "./Top4.vue?vue&type=script&lang=js&"
export * from "./Top4.vue?vue&type=script&lang=js&"
import style0 from "./Top4.vue?vue&type=style&index=0&id=4a256499&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a256499",
  null
  
)

export default component.exports